/* global define */

window._define('modules/postsList', ['jquery', 'common/pubsub', 'widgets/threadPost'], function ($, pubsub, ThreadPost) { 'use strict';

    function createPostsWidgets ($listPosts) {
        var options = {
                action: function (event, data) {
                    // broadcast event to application
                    pubsub.publish('thread.post.action', data);
                }
            };

        $listPosts.each(function (n, element) {
            new ThreadPost(options, element);
        });
    }

    $(function () {
        // list all posts, create widgets
        createPostsWidgets($('.js-thread-post'));

        // new post button
        $('.js-threadpost-new').on('click', function () {
            pubsub.publish('thread.post.action', {
                action: 'new'
            });
        });


        // form was submitted with errors
        if ($('.oc-form .error').length > 0) {
            pubsub.publish('thread.post.action', {
                action: 'post-errors'
            });
        }

    });

});
